import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearReaderManagerLogs, logReaderManagerEvents, sendReaderManagerLogsToS3 } from "../ReaderManagerSlice";
import ReaderManagerEventConstants from "../ReaderManagerEventConstants";

const WAIT_TIME_TO_SEND_LOGS = 10000;
export default function useReaderManagerLogs({currentWord, earlyReaderMode}) {
  
  const dispatch = useDispatch();
  const sendLogTimeout = useRef(null);

  const { readerManagerLogs } = useSelector((state) => state.readerManager);

  useEffect(() => {
    if (currentWord) {
      try{
        dispatch(
          logReaderManagerEvents({
            type: ReaderManagerEventConstants.WORD_INDEX_CHANGE,
            word: currentWord,
          })
        );
      }catch(e){
        // silence the error because logging isn't critical to the app's functionality
        console.log("Error in useReaderManagerLogs: ", e);
      }
    }
  }, [currentWord]);

  useEffect(() => {
    if (readerManagerLogs?.length) {
      try{
        const lastLogMessage = readerManagerLogs[readerManagerLogs.length - 1];
        // console.log("Reader Manager Logs: ", lastLogMessage);

        if (lastLogMessage.type === ReaderManagerEventConstants.SEND_RECORDING) {
          // clear the logs array because at this point, we are confident that the user has successfully finished a full story.
          // prevents the logs from being sent in the next story.
          dispatch(clearReaderManagerLogs());
        }

        // clear the timeout if it exists
        if (sendLogTimeout.current) {
          clearTimeout(sendLogTimeout.current);
        }

        // don't set a timeout if the event is anything that is interactive.
        const eventsToSkip = [
          ReaderManagerEventConstants.OPEN_MODAL,
          ReaderManagerEventConstants.INTERVENTION_ON_WORD,
          ReaderManagerEventConstants.INTERVENTION_ON_PHRASE,
          ReaderManagerEventConstants.SEND_RECORDING,
        ];
        // don't set a timeout if the early reader mode is one of the following
        const earlyReaderTypesToSkip = [
          'changeOnePart',
          'upAndDown',
          'letterFlies',
          'elkoninBoxes',
        ]
        const shouldSkipEarlyReader = earlyReaderTypesToSkip.find(type => earlyReaderMode?.[type] === true)

        if (eventsToSkip.includes(lastLogMessage.type)) {
          console.log("Skip setting / resetting the send log timeout for: ", lastLogMessage.type);
        }else if(shouldSkipEarlyReader){
          console.log("Skip setting / resetting the send log timeout for: ", shouldSkipEarlyReader);
        }else{
          // set / reset the next timeout to send the logs to S3
          sendLogTimeout.current = setTimeout(() => {
            dispatch(sendReaderManagerLogsToS3());
          }, WAIT_TIME_TO_SEND_LOGS);
        }
      }catch(e){
        // silence the error because logging isn't critical to the app's functionality
        console.log("Error in useReaderManagerLogs: ", e);
      }
    }

    return () => {
      if (sendLogTimeout.current) {
        clearTimeout(sendLogTimeout.current);
      }
    };
  }, [readerManagerLogs]);
}
